import { combineReducers } from 'redux';

import routes from '../../routes/reducers';
import request from '../../features/request/reducers';
import searchResults from '../../features/searchResults/reducers';
import bookings from '../../features/bookings/reducers';
import prices from '../../features/prices/reducers';
import processing from '../../features/processing/reducers';
import reviews from '../../features/reviews/reducers';
import accommodationReviews from '../../features/accommodationReviews/reducers';

const rootReducer = combineReducers({
  routes,
  request,
  searchResults,
  bookings,
  prices,
  processing,
  reviews,
  accommodationReviews,
});

export default rootReducer;
